import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getFunctions } from "firebase/functions";
import { getAnalytics } from "firebase/analytics";
import { getStorage } from "firebase/storage";

const firebaseConfig = {
  apiKey: "AIzaSyDqAZsZ83_rEi-3Dv2qErGT4XsabumpLf4",
  authDomain: "partslokator-new-web.firebaseapp.com",
  projectId: "partslokator-new-web",
  storageBucket: "partslokator-new-web.firebasestorage.app",
  messagingSenderId: "370633969821",
  appId: "1:370633969821:web:eb880b559b9560cf900474",
  measurementId: "G-F2SCX9Z5J5",
};

const app = initializeApp(firebaseConfig);

const auth = getAuth(app);
const db = getFirestore(app);
const functions = getFunctions(app);
const analytics = getAnalytics(app);
const storage = getStorage(app);

export { app, auth, db, functions, analytics, storage };
